import { getInventory_Red } from '../../Reducers/inventory/get-red';
import { getSamTypesRed } from '../../Reducers/sam/getSamTypesRed';
import { useReducer } from 'react';
import { globalInitialState } from '../initialStateGlobal';
import { patchSamRed } from '../../../business/Reducers/sam/patchSamRed';
import { putSamRed } from '../../../business/Reducers/sam/putSamRed';
import { getSamByIdRed } from '../../../business/Reducers/sam/getSamByIdRed';
import { putRechargeCounterRed } from '../../../business/Reducers/sam/putRechargeCounterRed';
import { configurationTrigger_Red } from '../../../business/Reducers/inventory/configurationTrigger-red';
import {
  GenericState,
  initialStatePutDisabledSam,
  PUT_DISABLE_SAM,
  PUT_DISABLE_SAM_ERROR,
  PUT_DISABLE_SAM_SUCCESS,
  putDisableSamRed,
} from '../../../business/Reducers/inventory/putDisableSamRed';
import {
  initialStateModifyWhiteList,
  PUT_DISABLE_WHITELIST,
  PUT_DISABLE_WHITELIST_ERROR,
  PUT_DISABLE_WHITELIST_SUCCESS,
  putModifyWhiteListRed,
} from '../../../business/Reducers/inventory/putModifyWhitListred';

export const useGetInventoryState = () => {
  const [state, dispatch] = useReducer(getInventory_Red, globalInitialState);
  return { state, dispatch };
};

export const useGetInvetoryToExcelState = () => {
  const [state, dispatch] = useReducer(getInventory_Red, globalInitialState);
  return { state, dispatch };
};

export const useSamTypes = () => {
  const [state, dispatch] = useReducer(getSamTypesRed, globalInitialState);
  return { state, dispatch };
};

export const useGetSamById = () => {
  const [state, dispatch] = useReducer(getSamByIdRed, globalInitialState);
  return { state, dispatch };
};

export const usePatchEditSamState = () => {
  const [state, dispatch] = useReducer(patchSamRed, globalInitialState);
  return { state, dispatch };
};

export const usePutEditSamState = () => {
  const [state, dispatch] = useReducer(putSamRed, globalInitialState);
  return { state, dispatch };
};

export const usePutRechargeCountersState = () => {
  const [state, dispatch] = useReducer(
    putRechargeCounterRed,
    globalInitialState
  );
  return { state, dispatch };
};

export const useGetConfigurationTriggerState = () => {
  const [state, dispatch] = useReducer(
    configurationTrigger_Red,
    globalInitialState
  );
  return { state, dispatch };
};

export const usePostConfigurationTriggerState = () => {
  const [state, dispatch] = useReducer(
    configurationTrigger_Red,
    globalInitialState
  );
  return { state, dispatch };
};

export const usePutDisableSamState = () => {
  const [state, dispatch] = useReducer(
    putDisableSamRed,
    initialStatePutDisabledSam
  );

  const initPutDisableSam = () => {
    return dispatch({ type: PUT_DISABLE_SAM });
  };
  const PutDisableSamSuccess = (payload: any) => {
    return dispatch({ type: PUT_DISABLE_SAM_SUCCESS, payload });
  };
  const PutDisableSamError = (error: any) => {
    return dispatch({ type: PUT_DISABLE_SAM_ERROR, payload: error });
  };
  return {
    state,
    initPutDisableSam,
    PutDisableSamSuccess,
    PutDisableSamError,
  };
};
export const usePutModifyWhiteListState = () => {
  const [state, dispatch] = useReducer(
    putModifyWhiteListRed,
    initialStateModifyWhiteList
  );

  const initPutModifyWhiteList = () => {
    return dispatch({ type: PUT_DISABLE_WHITELIST });
  };
  const PutModifyWhiteListSuccess = (payload: any) => {
    return dispatch({ type: PUT_DISABLE_WHITELIST_SUCCESS, payload });
  };
  const PutModifyWhiteListError = (error: any) => {
    return dispatch({ type: PUT_DISABLE_WHITELIST_ERROR, payload: error });
  };
  return {
    state,
    initPutModifyWhiteList,
    PutModifyWhiteListSuccess,
    PutModifyWhiteListError,
  };
};
